import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { Banner } from "./components/Banner";
import { Sidebar } from "./components/Sidebar";
import { About } from "./components/About";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  return (
      <Router>
        <div className="App">
          <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
          <main className={`main-content ${isSidebarOpen ? 'sidebar-open' : ''}`}>
                  <section id="banner">
                    <Banner />
                  </section>
                  <section id="about">
                    <About />
                  </section>
                  <section id="skills">
                    <Skills />
                  </section>
                  <section id="projects">
                    <Projects />
                  </section>
<section id="contact">
                    <Contact />
                  </section>
            <Footer />
          </main>
        </div>
      </Router>
  );
}

export default App;